// HeroSection.jsx
import React from 'react';
import './HeroSection.css';
import brandingConfig from '../config/branding.config.js';
import businessConfig from '../config/business.config.js';

const HeroSection = () => {
  const scrollToProducts = () => {
    const productsSection = document.querySelector('.products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="botanical-hero">
      {/* Decorative botanical elements */}
      <div className="hero-decoration left-decoration"></div>
      <div className="hero-decoration right-decoration"></div>

      <div className="hero-container">
        <div className="hero-main">
          {/* Text Content */}
          <div className="hero-text-content">
            <div className="hero-badge-top">
              <span className="badge-icon">🌿</span>
              <span>Natural • Traditional • Pure</span>
            </div>

            <h1 className="hero-main-title">
              Natural Botanicals for
              <span className="title-highlight"> Holistic Wellness</span>
            </h1>

            <p className="hero-description">
              Traditional African herbs and premium botanical products crafted with care.
            </p>

            {/* Single CTA */}
            <div className="hero-cta-group">
              <button className="hero-btn-primary" onClick={scrollToProducts}>
                Shop Collection
              </button>
            </div>
          </div>

          {/* Image/Visual Content */}
          <div className="hero-visual">
            <div className="visual-circle"></div>
            <div className="visual-content">
              <img
                src="/Gs.png"
                alt={brandingConfig.businessNameShort}
                className="hero-logo-botanical"
              />
              <div className="visual-accent accent-1"></div>
              <div className="visual-accent accent-2"></div>
              <div className="visual-accent accent-3"></div>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="hero-trust-bar">
          <div className="trust-item">
            <span className="trust-icon">✓</span>
            <span>100% Natural</span>
          </div>
          <div className="trust-item">
            <span className="trust-icon">✓</span>
            <span>Ethically Sourced</span>
          </div>
          <div className="trust-item">
            <span className="trust-icon">✓</span>
            <span>Free Shipping R500+</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
